//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: 'app',
  components: {
  },
}



// WEBPACK FOOTER //
// ./src/App.vue